<template>
  <div
    class="progress-bar"
    role="progressbar"
    :aria-valuenow="Math.round(clamped)"
    aria-valuemin="0"
    aria-valuemax="100"
    :style="height ? { height, borderRadius: `calc(${height} / 2)` } : undefined"
  >
    <div class="progress-fill" :style="{ width: `${clamped}%`, background: color }" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

/**
 * Thin progress bar (wraps the global .progress-bar/.progress-fill pair).
 * Pass the percentage — it clamps to 0–100 so call sites stop retyping
 * Math.min. Color takes a CSS value (semantic var(--…) tokens, or a
 * category's stored color); omit it for the accent default.
 */
const props = defineProps<{
  /** Percentage, 0–100. Values outside the range are clamped. */
  value: number
  /** CSS color for the fill, e.g. "var(--forest-600)". Default: accent. */
  color?: string
  /** Track height override, e.g. "10px". Default: the 4px .progress-bar. */
  height?: string
}>()

const clamped = computed(() => Math.min(100, Math.max(0, props.value)))
</script>
